import templates from "../templates";
import { getIconMap, getIcon } from "./helpers";

export const link = (data) => {
  return templates.find("generic", "linked_cell")(data);
};

export const tooltip = (data) => {
  // decide whether to use a tooltip, for plain strings, or a popover for
  // structured data like KeyValueCollections.
  const type = _.isString(data.tooltip) ? "tooltip" : "popover";
  return templates.find("generic", type)(data);
};

export const icon = (route, column, data) => {
  const { value } = data;
  const map = getIconMap(route, column);
  const icon = map ? map[value] : value;
  return icon ? getIcon(icon, value) : value;
};
